import { render, staticRenderFns } from "./dalinji.vue?vue&type=template&id=9e84c6ac"
import script from "./dalinji.vue?vue&type=script&lang=js"
export * from "./dalinji.vue?vue&type=script&lang=js"
import style0 from "./dalinji.vue?vue&type=style&index=0&id=9e84c6ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports